import { useQuery, WatchQueryFetchPolicy } from '@apollo/client'
import { auth } from 'api/Firebase'

import { GET_LOGGED_IN_USER, GetLoggedInUserQuery } from '@/graphql'

const useLoggedInUser = (
  fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network',
) => {
  const { data, loading, error } = useQuery<GetLoggedInUserQuery>(
    GET_LOGGED_IN_USER,
    {
      fetchPolicy, // TODO: clear cache on sign out might be better
    },
  )

  const user = data?.loggedInUser
  const roles = user?.groups || []
  const roleNames = roles.map(group => group.name)
  const hasOwnerRole = roles.some(role => role.isOwner)

  const handleLogout = async () => {
    await auth.signOut()
    window.location.replace('/auth/sign-in')
  }

  return {
    user: data?.loggedInUser,
    loading,
    error,
    roles,
    roleNames,
    hasOwnerRole,
    handleLogout,
  }
}

export default useLoggedInUser
